import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router';
import Nav from '../nav/Nav';
import Landing from '../landing/Landing';
import About from '../about/About';
import Books from '../books/Books';
import Contact from '../contact/Contact';
import Footer from '../footer/Footer';
import './App.css';

export default function App() {
  return (
    <div>
      <Router>
        <Nav />
        <Routes>
          <Route exact path='/' element={<Landing />} />
          {/* <Route exact path='/books' element={<Books />} /> */}
          <Route exact path='/about' element={<About />} />
          <Route exact path='/contact' element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}
